import React, { useEffect, useRef } from "react";
import Header from "../component/header";
import Banner from "../component/home/banner";
import Client from "../component/home/client";
import Step from "../component/home/step";
import Process from "../component/home/process";
import Technology from "../component/home/technology";
import Team from "../component/home/team";
import Partner from "../component/home/partner";
import Footer from "../component/footer";
import Slogen from "../component/home/slogen";
import Testimonial from "../component/hiredevelopers/testimonial";
import Faq from "../component/hiredevelopers/faq";

const Home = () => {
  useEffect(() => {
    document.body.className = "";
    document.title = "Hire The Top Skilled Resources";
    document.querySelector("meta[name='description']").content =
      "Destination To Get The Best Dedicated Developers Remotely!";
  }, []);

  const scrollToDiv = (ref) =>
    ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
  const el1 = useRef();

  return (
    <>
      <Header />
      <Partner reference={el1} />
      <Banner scrollToDiv={scrollToDiv} el1={el1} />
      <Client />
      <Slogen />
      <Step />
      {/* <Process /> */}
      <Technology />
      <Team />
      <Testimonial />
      <Faq />
      <Partner reference={el1} />
      <Footer />
    </>
  );
};

export default Home;
